import axiosInstance from "./axios";

// GET /home/ — the mixed Home timeline.
//
// Response: { next_event, items, next_cursor, has_more }
//   items[]:    { type: "post" | "event_start" | "event_end", timestamp, data }
//               post → PostReadSerializer, event_* → EventOccurrenceSerializer
//   next_event: the next upcoming occurrence (separate from the timeline) or null
//
// Home is friends-only (own + direct friends' posts); the backend applies that
// itself, so no scope is sent. The backend owns ordering; `next_cursor` is
// opaque and only ever echoed back.
export async function fetchHome(token, { cursor, signal } = {}) {
  const params = {};
  if (cursor) params.cursor = cursor;

  const { data } = await axiosInstance.get("/home/", {
    params,
    signal,
    headers: { Authorization: `Token ${token}` },
  });
  return data;
}
